export default __webpack_public_path__ + "static/media/twitch.61a237f0.svg";